import { render } from "./RepDshSummary1Clinic.vue?vue&type=template&id=6b28d159"
import script from "./RepDshSummary1Clinic.vue?vue&type=script&lang=js"
export * from "./RepDshSummary1Clinic.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__